mutation EnrichContact($input: EnrichContactInput!) {
    enrichContact(input: $input) {
        contact {
            id
        }
    }
}
